export default __webpack_public_path__ + "static/Whisnu Thomas Julianto-7f0cf91c77aa1adcae4fa62d0d073003.webp";